import { render, staticRenderFns } from "./SiteGroupsConfig.vue?vue&type=template&id=0709d61a&"
import script from "./SiteGroupsConfig.vue?vue&type=script&lang=js&"
export * from "./SiteGroupsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports